import { render, staticRenderFns } from "./EditorCodemirror.vue?vue&type=template&id=0637017b&"
import script from "./EditorCodemirror.vue?vue&type=script&lang=js&"
export * from "./EditorCodemirror.vue?vue&type=script&lang=js&"
import style0 from "./EditorCodemirror.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports